import { Link } from 'react-router-dom'
import './Page.css'
import './About.css'

function About() {
  return (
    <div className="page-container">
      <div className="hero hero-slim">
        <div className="hero-content">
          <div className="globe-container">
            <svg className="globe-svg" viewBox="0 0 600 600" preserveAspectRatio="xMidYMid meet">
              {/* External connection lines from globe to components */}
              {/* Top left - Resistor */}
              <line x1="50" y1="50" x2="220" y2="220" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3s" repeatCount="indefinite"/>
              </line>
              <g className="component external-resistor" transform="translate(20, 20)">
                <path d="M0 15 H10 L12 12 L16 18 L20 12 L22 15 H30" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Top right - Capacitor */}
              <line x1="550" y1="50" x2="380" y2="220" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3.2s" repeatCount="indefinite"/>
              </line>
              <g className="component external-capacitor" transform="translate(550, 20)">
                <line x1="0" y1="15" x2="10" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="10" y1="10" x2="10" y2="20" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="15" y1="10" x2="15" y2="20" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="15" y1="15" x2="25" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Bottom left - Transistor/Diodes */}
              <line x1="50" y1="550" x2="220" y2="380" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3.1s" repeatCount="indefinite"/>
              </line>
              <g className="component external-transistor" transform="translate(20, 550)">
                <line x1="0" y1="15" x2="8" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="8" y1="15" x2="12" y2="10" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="8" y1="15" x2="12" y2="20" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="12" y1="10" x2="12" y2="20" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="12" y1="15" x2="20" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Bottom right - Inductor */}
              <line x1="550" y1="550" x2="380" y2="380" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="2.9s" repeatCount="indefinite"/>
              </line>
              <g className="component external-inductor" transform="translate(550, 550)">
                <line x1="0" y1="15" x2="5" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <path d="M5 15 Q7 10, 9 15 T13 15 T17 15" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="17" y1="15" x2="25" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Top center - Op-Amp */}
              <line x1="300" y1="30" x2="300" y2="200" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3.3s" repeatCount="indefinite"/>
              </line>
              <g className="component external-opamp" transform="translate(280, 10)">
                <polygon points="0,10 20,5 20,25 0,20" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="20" y1="10" x2="30" y2="10" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="20" y1="20" x2="30" y2="20" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Bottom center - Transformer */}
              <line x1="300" y1="570" x2="300" y2="400" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3.4s" repeatCount="indefinite"/>
              </line>
              <g className="component external-transformer" transform="translate(280, 570)">
                <line x1="0" y1="15" x2="5" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <ellipse cx="12.5" cy="10" rx="5" ry="3" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <ellipse cx="12.5" cy="20" rx="5" ry="3" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="20" y1="15" x2="25" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Left center - Diode */}
              <line x1="30" y1="300" x2="180" y2="300" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3.5s" repeatCount="indefinite"/>
              </line>
              <g className="component external-diode" transform="translate(10, 290)">
                <line x1="0" y1="15" x2="8" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <polygon points="8,10 15,15 8,20" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="15" y1="10" x2="15" y2="20" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="15" y1="15" x2="25" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Right center - Crystal/Oscillator */}
              <line x1="570" y1="300" x2="420" y2="300" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="external-connection">
                <animate attributeName="opacity" values="0.3;0.5;0.3" dur="3.6s" repeatCount="indefinite"/>
              </line>
              <g className="component external-crystal" transform="translate(550, 290)">
                <rect x="5" y="10" width="10" height="10" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="0" y1="15" x2="5" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
                <line x1="15" y1="15" x2="25" y2="15" stroke="var(--accent)" strokeWidth="1.5" opacity="0.5"/>
              </g>
              
              {/* Globe base circle */}
              <circle cx="300" cy="300" r="150" fill="none" stroke="var(--accent)" strokeWidth="1.5" opacity="0.3"/>
              
              {/* Latitude lines */}
              <ellipse cx="300" cy="300" rx="150" ry="75" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              <ellipse cx="300" cy="250" rx="130" ry="65" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              <ellipse cx="300" cy="350" rx="130" ry="65" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              
              {/* Longitude lines */}
              <path d="M 300 150 Q 300 300, 300 450" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              <path d="M 150 300 Q 300 300, 450 300" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              <path d="M 200 180 Q 300 300, 400 420" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              <path d="M 400 180 Q 300 300, 200 420" fill="none" stroke="var(--accent)" strokeWidth="1" opacity="0.22"/>
              
              {/* Connection nodes */}
              <circle cx="220" cy="220" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="380" cy="220" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.5s" repeatCount="indefinite"/>
              </circle>
              <circle cx="220" cy="380" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="380" cy="380" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.8s" repeatCount="indefinite"/>
              </circle>
              <circle cx="300" cy="200" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.3s" repeatCount="indefinite"/>
              </circle>
              <circle cx="300" cy="400" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.4s" repeatCount="indefinite"/>
              </circle>
              <circle cx="180" cy="300" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.6s" repeatCount="indefinite"/>
              </circle>
              <circle cx="420" cy="300" r="4" fill="var(--accent)" opacity="0.7" className="globe-node">
                <animate attributeName="opacity" values="0.45;0.8;0.45" dur="2.1s" repeatCount="indefinite"/>
              </circle>
              
              {/* Connection lines between nodes */}
              <line x1="220" y1="220" x2="300" y2="200" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="3s" repeatCount="indefinite"/>
              </line>
              <line x1="380" y1="220" x2="300" y2="200" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="3.2s" repeatCount="indefinite"/>
              </line>
              <line x1="220" y1="380" x2="300" y2="400" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="3.1s" repeatCount="indefinite"/>
              </line>
              <line x1="380" y1="380" x2="300" y2="400" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="2.9s" repeatCount="indefinite"/>
              </line>
              <line x1="220" y1="220" x2="180" y2="300" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="3.3s" repeatCount="indefinite"/>
              </line>
              <line x1="380" y1="220" x2="420" y2="300" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="2.8s" repeatCount="indefinite"/>
              </line>
              <line x1="300" y1="200" x2="300" y2="400" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="3.5s" repeatCount="indefinite"/>
              </line>
              <line x1="180" y1="300" x2="420" y2="300" stroke="var(--accent)" strokeWidth="1.5" opacity="0.4" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.5;0.25" dur="3.4s" repeatCount="indefinite"/>
              </line>
              
              {/* Central hub node */}
              <circle cx="300" cy="300" r="6" fill="var(--accent)" opacity="0.85" className="globe-node hub">
                <animate attributeName="opacity" values="0.65;0.95;0.65" dur="2s" repeatCount="indefinite"/>
                <animate attributeName="r" values="5;7;5" dur="2s" repeatCount="indefinite"/>
              </circle>
              
              {/* Additional connection lines to hub */}
              <line x1="300" y1="300" x2="220" y2="220" stroke="var(--accent)" strokeWidth="1.5" opacity="0.35" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.45;0.25" dur="2.5s" repeatCount="indefinite"/>
              </line>
              <line x1="300" y1="300" x2="380" y2="220" stroke="var(--accent)" strokeWidth="1.5" opacity="0.35" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.45;0.25" dur="2.7s" repeatCount="indefinite"/>
              </line>
              <line x1="300" y1="300" x2="220" y2="380" stroke="var(--accent)" strokeWidth="1.5" opacity="0.35" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.45;0.25" dur="2.6s" repeatCount="indefinite"/>
              </line>
              <line x1="300" y1="300" x2="380" y2="380" stroke="var(--accent)" strokeWidth="1.5" opacity="0.35" className="connection-line">
                <animate attributeName="opacity" values="0.25;0.45;0.25" dur="2.4s" repeatCount="indefinite"/>
              </line>
            </svg>
          </div>
          
          <div className="hero-text">
            <h1 className="title">
              <span className="title-line">Ending Obsolescence</span>
              <span className="title-line title-accent">One Document</span>
              <span className="title-line">At A Time</span>
            </h1>
            
            <p className="description">
              When schematics disappear, repair becomes guesswork. When documentation is locked away or never released, perfectly functional hardware is declared obsolete. Alchemy Electronics exists to break that cycle.
            </p>

            <div className="cta-buttons">
              <Link to="/docs" className="btn btn-primary">
                Docs
              </Link>
              <Link to="/donate" className="btn btn-secondary">
                Donate
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <section className="about-section">
        <h2>Who We Are</h2>
        <p>
          This is an open, community-driven repository for reverse-engineered electronics schematics. Its purpose is to document real hardware—accurately, publicly, and permanently—so devices don&apos;t become disposable just because information was withheld.
        </p>
      </section>

      <section className="about-section">
        <h2>What We Stand For</h2>
        
        <div className="stand-for-item">
          <h3>Open access, by design</h3>
          <p>
            If knowledge is required to repair, maintain, or understand a device, it should not be hidden behind paywalls, dead forums, or corporate indifference. Access isn&apos;t a bonus feature here—it&apos;s the baseline.
          </p>
        </div>

        <div className="stand-for-item">
          <h3>Community verification over authority</h3>
          <p>
            Reverse engineering is not mythology. Claims get tested. Schematics get reviewed. Errors get corrected. This platform favors evidence, discussion, and iteration over reputation or credentials.
          </p>
        </div>

        <div className="stand-for-item">
          <h3>Structure beats chaos</h3>
          <p>
            Loose PDFs rot. Contextless diagrams mislead. Schematics here are organized, searchable, versioned, and tied to real devices, revisions, and known behaviors. The goal isn&apos;t accumulation—it&apos;s usability.
          </p>
        </div>

        <div className="stand-for-item">
          <h3>Built to last</h3>
          <p>
            Short-lived platforms produce short-lived knowledge. This project is designed with longevity in mind: technically, socially, and economically. If the documentation doesn&apos;t survive time, the mission fails.
          </p>
        </div>
      </section>
    </div>
  )
}

export default About

